function initLocalVideo(videoWrapper) {
  const trigger = videoWrapper.querySelector('[data-video-trigger]');
  const video = videoWrapper.querySelector('video');

  if (!trigger || !video) {
    return;
  }

  // Hide native controls until the custom play interaction starts playback.
  video.removeAttribute('controls');

  trigger.addEventListener('click', () => {
    trigger.classList.add('video__poster--hidden');
    video.setAttribute('controls', 'controls');

    video.play().catch(() => {
      // Ignore autoplay promise rejections from strict browser policies.
    });
  });
}

function initVideo() {
  const localVideos = document.querySelectorAll('[data-video-local]');

  localVideos.forEach((videoWrapper) => {
    initLocalVideo(videoWrapper);
  });
}

export default initVideo;
